import {Network} from "./Network"

export class ProfessionService {
    static getAll () {
        return Network.fetch(false, '/profession')
    }
}
